import { makeAutoObservable } from 'mobx'
import { queryClient } from '../../../../../App'
import {
  ActiveOrder,
  CreateServiceRequestFrom,
  DiagnosticFormType,
  SearchFormType,
  ServiceCenterForm,
} from '../types/NewDrawers.types'

type DrawerMode = 'search'

interface NewCreateServiceRequestStoreType {
  drawerMode: DrawerMode
  isDrawerOpen: boolean
  isResultsDrawerOpen: boolean
  isCreateDrawerOpen: boolean
  isDiagnosticDrawerOpen: boolean
  isCheckDrawerOpen: boolean
  isShowAllRequestsDrawerOpen: boolean
  searchParams: SearchFormType | {}
  selectedRequest: Record<string, any> | null
  createFormData: CreateServiceRequestFrom | null
  diagnosticData: DiagnosticFormType | null
  serviceCenterData: ServiceCenterForm | null
  incidentTypeId: number | null
  malfunctionTypeId: number | null
  serviceCenterMalfunctionId: number | null
  senderId: number | null
  resetAll: boolean
  fromExistedRequest: boolean
  existedRequestId: number | null
}

class NewCreateServiceRequestStore implements NewCreateServiceRequestStoreType {
  drawerMode: 'search' = 'search'
  isDrawerOpen = false
  isResultsDrawerOpen = false
  searchParams: {} | SearchFormType = {}
  selectedRequest: Record<string, any> | null = null
  isCreateDrawerOpen: boolean = false
  createFormData: CreateServiceRequestFrom | null = null
  isShowAllRequestsDrawerOpen: boolean = false
  isDiagnosticDrawerOpen: boolean = false
  diagnosticData: DiagnosticFormType | null = null
  isCheckDrawerOpen: boolean = false
  incidentTypeId: number | null = null
  malfunctionTypeId: number | null = null
  serviceCenterMalfunctionId: number | null = null
  senderId: number | null = null
  resetAll: boolean = false
  fromExistedRequest: boolean = false
  existedRequestId: number | null = null
  activeServiceOrder: ActiveOrder | null = null
  isServerOrdersDrawerOpen: boolean = false
  serviceCenterData: ServiceCenterForm | null = null

  constructor() {
    makeAutoObservable(this)
  }

  setDrawerMode = (mode: DrawerMode) => {
    this.drawerMode = mode
  }

  setIsDrawerOpen = (value: boolean) => {
    this.isDrawerOpen = value
  }

  setIsResultsDrawerOpen = (value: boolean) => {
    this.isResultsDrawerOpen = value
  }

  setIsCreateDrawerOpen = (value: boolean) => {
    this.isCreateDrawerOpen = value
  }

  setIsDiagnosticDrawerOpen = (value: boolean) => {
    this.isDiagnosticDrawerOpen = value
  }

  setIsCheckDrawerOpen = (value: boolean) => {
    this.isCheckDrawerOpen = value
  }

  setIsShowAllRequestsDrawerOpen = (value: boolean) => {
    this.isShowAllRequestsDrawerOpen = value
  }

  setSelectedRequest = (request: Record<string, any> | null) => {
    this.selectedRequest = request
  }

  setSearchParams = (params: SearchFormType | {}) => {
    this.searchParams = params
  }

  setCreateFormData = (data: CreateServiceRequestFrom | null) => {
    this.createFormData = data
  }

  setDiagnosticData = (data: DiagnosticFormType | null) => {
    this.diagnosticData = data
  }

  setServiceCenterData = (data: ServiceCenterForm | null) => {
    this.serviceCenterData = data
  }

  setIncidentTypeId = (id: number | null) => {
    this.incidentTypeId = id
  }
  setSenderId = (id: number | null) => {
    this.senderId = id
  }
  setMalfunctionTypeId = (id: number | null) => {
    this.malfunctionTypeId = id
  }
  setServiceCenterMalfunctionTypeId = (id: number | null) => {
    this.serviceCenterMalfunctionId = id
  }

  setFromExistedRequest = (value: boolean) => {
    this.fromExistedRequest = value
  }

  setExistedRequestId = (id: number | null) => {
    this.existedRequestId = id
  }

  setResetAll = () => {
    queryClient.invalidateQueries({ queryKey: ['get-active-service-orders'] })
    this.resetAll = true

    setTimeout(() => {
      this.resetAll = false
    }, 50)
  }

  setActiveServiceOrder = (order: ActiveOrder | null) => {
    this.activeServiceOrder = order
  }

  setIsServerOrdersDrawerOpen = (value: boolean) => {
    this.isServerOrdersDrawerOpen = value
  }
}

export const createServiceRequestStore = new NewCreateServiceRequestStore()
